module.exports = __webpack_public_path__ + "img/20190712163555047.408aec22.png";